import { render, staticRenderFns } from "./MtMaterialsCateList.vue?vue&type=template&id=5fd8a4e1&scoped=true&"
import script from "./MtMaterialsCateList.vue?vue&type=script&lang=js&"
export * from "./MtMaterialsCateList.vue?vue&type=script&lang=js&"
import style0 from "./MtMaterialsCateList.vue?vue&type=style&index=0&id=5fd8a4e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd8a4e1",
  null
  
)

export default component.exports